import React, { FC, type ReactNode } from 'react'
import styled from 'styled-components'
import { Icon } from 'components/base-ui'
import { generateSrcSet } from 'helpers/image'

interface MenuItemProps {
  testId?: string
  onClick?: () => void
  icon?: string
  imagePath?: string
  title: ReactNode
  iconAction?: string
  isActive?: boolean
  outline?: boolean
  isShowIconPrefix?: boolean
}

const MenuItem: FC<MenuItemProps> = ({
  testId,
  onClick,
  icon,
  imagePath,
  title,
  iconAction,
  isActive = true,
  outline = false,
  isShowIconPrefix = true,
}) => {
  const handleClick = () => {
    if (isActive && typeof onClick === 'function') {
      onClick()
    }
  }
  return (
    <CardWrapper onClick={handleClick} isActive={isActive} outline={outline} data-testid={testId}>
      <ListItemDetail isActive={isActive}>
        {isShowIconPrefix ? (
          <IconWrapper>
            {imagePath ? (
              <img alt="" src={imagePath} srcSet={generateSrcSet(imagePath, 'png')} />
            ) : icon ? (
              <Icon name={icon} />
            ) : null}
          </IconWrapper>
        ) : null}
        {title}
      </ListItemDetail>
      {iconAction && <Icon name={iconAction} />}
    </CardWrapper>
  )
}

export default MenuItem

const CardWrapper = styled.div<{ isActive: boolean; outline: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 18px;
  border: 1px solid ${({ theme }) => theme.colors.lightGrey};
  border-radius: 10px;
  background: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.gray800};
  cursor: pointer;

  box-shadow: ${({ theme, outline }) =>
    outline ? `${theme.colors.primary} 0px 0px 0px 2px inset, rgba(0, 0, 0, 0.15) 0px 1px 6px` : 'none'};

  i:before {
    color: ${({ theme, isActive }) => (isActive ? theme.colors.primary : theme.colors.baseGrey)};
  }
`

const ListItemDetail = styled.div<{ isActive: boolean }>`
  display: flex;
  column-gap: 10px;
  align-items: center;
  font-weight: bold;
  color: ${({ theme, isActive }) => (isActive ? theme.colors.gray800 : theme.colors.baseGrey)};
`
const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 36px;

  margin-top: -5px;
  margin-bottom: -5px;
  margin-right: -9px;
  position: relative;
  left: -11px;

  img {
    width: 100%;
    max-width: 32px;
  }
`
